<nav class="navbar px-2">
  <div class="d-flex justify-content-between align-items-center w-100">

    <a class="navbar-brand" routerLink="/">
      <img src="assets/img/logo/mile-express-no-bg.png" width="100vw" height="35vh" alt="">
    </a>
    <div class="">
      <div class="d-flex align-items-center gap-3">
        <!-- Warehouse selector (sempre visível quando houver warehouses no token) -->
        @if (warehouses.length > 0) {
          <div class="d-flex align-items-center gap-1">
            <label class="form-label mb-0 small text-nowrap">Armazém:</label>
            <select class="form-select form-select-sm" style="min-width: 120px;"
                    [ngModel]="selectedWarehouse" (ngModelChange)="onWarehouseChange($event)"
                    [compareWith]="compareWarehouse">
              @for (wh of warehouses; track wh.id) {
                <option [ngValue]="wh">{{ wh.name }}</option>
              }
            </select>
          </div>
        }
        <!-- Menu theme -->
        <select class="form-select" [(ngModel)]="currentTheme" (change)="onThemeChange($event)">
          <option value="light">🌞 Light</option>
          <option value="dark">🌙 Dark</option>
        </select>

        <!-- Menu de notificação -->
        <app-notification />

        <!-- Menu -->
        <app-menu [menu]="menu" />

      </div>
    </div>
  </div>
</nav>
